export const CONTAINER_DISPATCH_DATE_SAVED_EVENT = 'container-dispatch-date-saved';

export function notifyContainerDispatchDateSaved(date: string) {
  window.dispatchEvent(
    new CustomEvent(CONTAINER_DISPATCH_DATE_SAVED_EVENT, { detail: { date } })
  );
}
